import React, { useState } from 'react'
import Modal from '../../components/modal/modal'
import Input from '../../components/forms/input/input'
import Button from '../../components/button/button'

const ApplyClassModal = ({ onApply, onClose }) => {
  const [detail, setDetail] = useState('')
  return (
    <Modal onClose={onClose} title='加入班级'>
      <Input
        placeholder='请输入班级码'
        onChange={v => { setDetail(v) }}
        defaultValue={detail}
        autoFocus={true}
      />
      <div style={{ textAlign: 'center' }}>
        <Button
          theme={'submit'}
          label={window.L('teach.button.submit')}
          onClick={() => {
            onApply(detail)
          }}
        />
      </div>
    </Modal>
  )
}

export default ApplyClassModal
